import _get from 'lodash/get'

export const get_email_templates = state => _get(state, 'emailtemplates.emailtemplates.email_templates', [])

export default get_email_templates
